import { useCallback, useEffect, useState } from 'react'
import { useSearch } from '@faststore/sdk'

import { useFilter } from './useFilter'
import Facets from './Facets'
import SelectedFacets from './SelectedFacets'
import type { Facet, FacetValue } from './types'

import './filter.scss'

interface Props {
  facetsv2?: Facet[]
  isOpen?: boolean
  onDismiss?: () => void
  testId?: string
}

function Filter({ facetsv2 }: Readonly<Props>) {
  const {
    setFacets,
    toggleFacet,
    setFacet,
    state: { selectedFacets },
  } = useSearch()

  const { facets, selected, expanded, dispatch } = useFilter(facetsv2)

  const filterFacets = useCallback(() => {
    if (!facetsv2) {
      return []
    }

    return selected
      .map(
        (filter) =>
          facetsv2
            ?.find((facet) => facet.key === filter.key)
            ?.values.find((value) => value.value === filter.value) as FacetValue
      )
      .filter((item) => item?.key !== 'category-1' && item)
  }, [facetsv2, selected])

  const [filteredFacets, setFilteredFacets] = useState<FacetValue[]>(
    filterFacets()
  )

  useEffect(() => {
    setFilteredFacets(filterFacets())
  }, [filterFacets])

  return (
    <div className="hidden-mobile">
      {selected && filteredFacets && (
        <SelectedFacets
          filteredFacets={filteredFacets}
          selectedFacets={selected}
          removeAllFacet={() => dispatch({ type: 'selectFacets', payload: [] })}
          removeFacet={toggleFacet}
        />
      )}
      <Facets
        initialFacets={facetsv2}
        facetsv2={facets}
        testId="desktop-store-filter"
        indicesExpanded={expanded}
        onFacetChange={(facet, type) => {
          if (type === 'RANGE') {
            setFacet(facet, true)
          } else {
            const newFacet = selectedFacets.filter(
              (obj) => obj.key !== facet.key
            )

            toggleFacet(facet)
            setFacets(newFacet)
          }
        }}
        onAccordionChange={(index) =>
          dispatch({ type: 'toggleExpanded', payload: index })
        }
      />
    </div>
  )
}

export default Filter
